import styles from "../moveout-checklist.module.css";

const FormHeader = ({ moveOutCheckListInfo }) => {
  function formatDateUS(dateString) {
    const date = new Date(dateString);
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Month is 0-indexed
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }
  return (
    <div className={`${styles.CheckListConSec}`}>
      <p className={`${styles.CheckListTitle}`}>Move-Out Condition Report</p>
      <p className={`${styles.CheckListText}`}>This Move-Out Condition Report is part of the Lease Agreement dated <span>{formatDateUS(moveOutCheckListInfo?.lease_date)}</span> between <span>{moveOutCheckListInfo?.tenant_names}</span> (Tenant) and <span>{moveOutCheckListInfo?.owner_name}</span> (Landlord) for the property located at <span>{moveOutCheckListInfo?.address}</span>.</p>
      <p className={`${styles.CheckListText}`}>The Landlord/Manager and Tenant have each inspected the property listed above. Tenant understands that this Condition Report is a part of their Lease Agreement and will used to document the condition of the dwelling upon gaining occupancy and upon vacating.</p>
      <p className={`${styles.CheckListTextTwo}`}>YOU SHOULD COMPLETE THIS CHECKLIST, NOTING THE CONDITION OF THE RENTAL PROPERTY, AND RETURN IT TO THE LANDLORD WITHIN 7 DAYS AFTER OBTAINIG POSESSION OF THE RENTAL UNIT. YOU ARE ALSO ENTITLED TO REQUEST AND RECEIVE A COPY OF THE LAST TERMINATION INVENTORY CHECKLIST WHICH SHOWS WHAT CLAIMS WERE CHARGABLE TO THE LAST PROIR TENANTS.</p>
    </div>
  );
};

export default FormHeader;
